import {DailyRewardType} from './DailyRewardsStore.constants';
import {RewardFrontend} from '@/stores/DailyRewardsStore/DailyRewardsStore.types';

import {Store} from '@/stores/Store';

export class DailyRewardsStore extends Store<{
  rewards: Array<RewardFrontend>;
  isRewardClaimed: boolean;
  claimRewardError: unknown;
}> {
  constructor() {
    super({
      rewards: [],
      isRewardClaimed: false,
      claimRewardError: null,
    });
  }

  public getRewards(): Array<RewardFrontend> {
    return this.state.rewards;
  }

  public isRewardClaimed(): boolean {
    return this.state.isRewardClaimed;
  }

  public getClaimRewardDaily(): unknown {
    return this.state.claimRewardError;
  }

  public getCurrentReward(): RewardFrontend | undefined {
    return this.state.rewards.find((r) => r.isCurrent);
  }

  public getCurrentRewardType(): DailyRewardType | undefined {
    return this.getCurrentReward()?.reward.type;
  }

  public setRewards(rewards: Array<RewardFrontend>): void {
    this.setValue('rewards', rewards);
  }

  public setRewardClaimed(): void {
    this.setValue('isRewardClaimed', true);
  }

  public setClaimRewardError(claimRewardError: unknown): void {
    this.setValue('claimRewardError', claimRewardError);
  }

  public isDailyRewardsHasGift(): boolean {
    return this.state.rewards.some((r) => r.isGift);
  }
}
